<div class="modal-dialog modal-confirm">
  <div class="modal-content">
    <div class="modal-header">
      <div class="icon-box" [ngClass]="bgColor">
        <em [ngClass]="type"></em>
      </div>
      <h4 class="modal-title w-100">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <p class="text-center ms-font">{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-block" [ngClass]="bgColor" (click)="modal.close()">
        OK
      </button>
    </div>
  </div>
</div>
